<template>
  <section>
    <b-row v-if="! deleted && chartType=='line'">
      <b-col>
        <h5 v-show="loaded">
          <b-btn size="xs" variant="danger" v-b-tooltip.hover title="Rimuovi indicatore" v-b-modal.ask>
            <font-awesome-icon icon="times" />
          </b-btn>
          {{ name }}</h5>


        <GChart
          :settings="{ packages: ['corechart', 'line'] }"
          type="LineChart"
          :data="chartData"
          :options="chartOptions"
          @ready="onChartReady"
        />

      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table striped :items="tableData" :fields="tableHeaders"></b-table>
      </b-col>

      <b-modal id="ask" title="Conferma?"
                header-bg-variant="warning"
                ok-variant="danger"
                ok-title="Rimuovi"
                @ok="remove"
                >
        <p class="my-4">Rimuovere l'indicatore <strong>{{ name }}</strong>?</p>
      </b-modal>
    </b-row>
    <b-row v-if="! deleted && chartType=='scatter'">
      <b-col>
        <apexchart type="scatter" height="350"
                  :options="scatterOptions"
                  :series="series" />
      </b-col>
    </b-row>
  </section>
</template>

<script>
export default {
  name: "IPGVisual",
  props: [ '$store', 'name', 'loaded', 'indicatorId', 'fromMonth', 'toMonth' ],

  data() {
    return {
      chartReady: false,
      chartData: [['Site', 'IPG']],
      chartOptions: {
        chartArea: {
          width: "100%"
        }
      },
      tableHeaders: [],
      tableData: [],
      deleted: false,
      customerGuid: null,
      formulaId: null,
      tags: [],
      sites: [],
      excludedSites: [],
      chartType: 'line',
      scatterOptions: {
        chart: {
          zoom: {
            enabled: true,
            type: 'xy'
          }
        }
      },
      series: []
    }
  },

  methods: {
    load(customerGuid, formulaId, tags, sites, excludedSites, fromMonth, toMonth, sampling) {

      if(customerGuid) {
        this.customerGuid = customerGuid
        this.formulaId = formulaId
        this.tags = tags
        this.sites = sites
        this.excludedSites = excludedSites
        this.sampling = sampling
      }

      let request = {
        customerGuid: customerGuid,
        formulaId,
        tags: tags ? tags.filter( t => t != null ) : [],
        sites: sites ? sites.map( s => s.guid).filter( s => s.guid != null ) : [],
        excludedSites: excludedSites ? excludedSites.map( s => s.guid).filter( s => s.guid != null ) : [],
        sampling: 'm',
        fromMonth: fromMonth,
        toMonth: toMonth
      }
      this.$store.dispatch("charts/ipg", request).then(data => {
        if(data.scatter) {
          this.chartType = 'scatter'
          this.series = []
          this.series.push({
            name: "IPG",
            data: data.scatter.map(v => {
              return [ v.EE, v.IPG ]
            })
          })
        }
        if(data.items && data.items.length) {
          this.chartType = 'line'
          this.$notify({
            type: "success",
            text: "IPG aggiornati",
            title: 'Successo'
          }); 
          // this.$toasted.show('IPG aggiornati', { duration: 3000, icon : 'check', theme: "bubble" })

          var table = [['Site', 'IPG', data.parameter, data.vector]];

          let avgIPG = 0;
          data.items.forEach( e => avgIPG += e.IPG)
          avgIPG = avgIPG / data.items.length

          this.chartData = [['Site', 'IPG', 'IPG medio ('+ avgIPG.toFixed(2) +')']]

          data.items.forEach( e => {
            table.push([
              e.siteName, e.IPG, e.parameterValue, e[data.vector]
            ])
            this.chartData.push([
              e.siteName, e.IPG, avgIPG
            ])
          })

          var dataTable = google.visualization.arrayToDataTable(table)
          this.chartOptions = {
            legend: { position: 'top', maxLines: 3 },
            height: 400,
            vAxis: { title: data.name },
            hAxis: { title: 'Siti' },
          }


          this.tableHeaders = [
            { sito: { label: 'Sito', sortable: true } },
            { IPG: { label: 'IPG', sortable: true } },
            { Parameter: { label: data.parameter, sortable: true } },
            { Vector: { label: data.vector, sortable: true } },
          ]
          this.tableData = data.items.map( e => {
            return {
              sito: e.siteName,
              IPG: e.IPG.toFixed(2),
              Parameter: e.parameterValue,
              Vector: e[data.vector].toFixed(2)
            }
          })
        }
      })
    },
    remove() {
      let data = {
        indicatorId: this.indicatorId
      }
      this.$store.dispatch('users/removeIndicator', data).then( response => {
        this.$store.dispatch('users/get', this.$store.state.user.id)
      })
      this.deleted = true

    },
    onChartReady() {
      this.chartReady = true
    }
  },
  computed: {

  },
  watch: {
    months() {
      this.load()
    },
    dashboardMonths() {
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/IPG/IPGVisual.vue